import React, { Component } from 'react';
import Slider from 'react-slick';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Translation } from 'react-i18next';
import PropType from 'prop-types';
import { map } from 'lodash';

function Arrow({ type, onClick }) {
  let className = type === 'next' ? 'nextArrow' : 'prevArrow';
  className += ' arrow';
  const char = type === 'next' ? <FontAwesomeIcon icon={faChevronRight} />
    : <FontAwesomeIcon icon={faChevronLeft} />;
  return (
    <div className={className} onClick={onClick}>
      {char}
    </div>
  );
}

Arrow.propTypes = {
  type: PropType.string,
  onClick: PropType.func,
};

export default class Campaign extends Component {
  componentDidMount() {
    const { fetchAllCampaignAction } = this.props;
    fetchAllCampaignAction({
      pos: 0,
      count: 10,
    });
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
    };

    const { campaigns = [] } = this.props;
    settings.slidesToShow = Math.min(4, campaigns.length);
    settings.slidesToScroll = 1;

    return (
      <Translation>
        {(t) => (
          <div className="carousel ">
            <h2 className="mb-0 landing__contact-header-h2">
              {t('landing.preferential_exchange')}
            </h2>
            <h5 className="landing__contact-header-h5">
              {t('landing.new_trading_experience')}
            </h5>
            <Slider
              nextArrow={<Arrow type="next" />}
              prevArrow={<Arrow type="prev" />}
              {...settings}
            >
              {map([...campaigns], (campaign) => (
                <div className="carousel__item">
                  <a href={`${campaign.link}`} rel="noreferrer" target="_blank" className="carousel__item-link">
                    <div className="carousel__item-title">
                      {window.localStorage.getItem('LANG') === 'vi' ? campaign.title.VI : campaign.title.EN}
                    </div>
                    <div className="carousel__item-img">
                      <img
                        src={`${campaign.path}`}
                        alt="Anh"
                        className="slider-img"
                      />
                    </div>
                    <div className="carousel__item-text">
                      {window.localStorage.getItem('LANG') === 'vi' ? campaign.short_content.VI : campaign.short_content.EN}
                    </div>
                    <div className="carousel__item-link">
                      <a href={`${campaign.link}`} rel="noreferrer" target="_blank" className="carousel__item-link">
                        {t('landing.check_now')}
                      </a>
                    </div>
                  </a>
                </div>
              ))}
            </Slider>
          </div>
        )}
      </Translation>
    );
  }
}

Campaign.propTypes = {
  fetchAllCampaignAction: PropType.func,
  campaigns: PropType.array,
};
